import { Http } from '@/lib/http';

export class NotificationSettingService extends Http {
  constructor() {
    super();
    this.endpoint = 'settings/system-settings/notifications/';
  }

  updateNotificationSettings(id, updates) {
    return this.httpClient().patch(`${this.endpoint}${id}`, updates);
  }

  getNotificationSettings() {
    return this.httpClient().get(`${this.endpoint}`);
  }

  getNotificationSettingsByModuleName(moduleName) {
    return this.httpClient().get(`${this.endpoint}${moduleName}`);
  }

  deleteNotificationSettings(id) {
    return this.httpClient().delete(`${this.endpoint}${id}`);
  }
}
